// dependencies
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
// hooks
import useRedux from '@/hooks/useRedux';
// components
import { ActionModal } from '@digital_monorepo/lib-common';

const Error404 = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { getAuthData } = useRedux();
  const { isLoggedIn } = getAuthData();

  // Redirect immediately to login when logged out
  useEffect(() => {
    if (!isLoggedIn) {
      navigate('/login');
    }
  }, [isLoggedIn, navigate]);

  return (
    <>
      <ActionModal
        t={t}
        open
        i18nPath='ERROR.ERROR_404'
        onClose={() => {
          navigate(isLoggedIn ? '/' : '/login');
        }}
        yesAction={() => {
          navigate(isLoggedIn ? '/' : '/login');
        }}
      />
    </>
  );
};

export default Error404;
